import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { LoaderCirleComponent } from "./loader-cirle.component";


@NgModule({
    declarations: [LoaderCirleComponent],
    imports:[CommonModule],
    exports: [LoaderCirleComponent]
})
export class LoaderCirleModule{
    constructor(){
        
    }
}